import React, { PureComponent } from 'react'
import classNames from 'classnames'
import { Plural } from '@lingui/macro'

import { Card } from '../../../components/common/card/Card'
import { CardTitle } from '../../../components/common/card/CardTitle'
import { linkBuilder } from '../../../../../shared/linkBuilder'
import { Flex } from 'front-end/src/components'
import IconDoc from 'front-end/src/components/common/icon/IconDoc'

import './WorkspaceCard.less'

export interface IWorkspaceCardProps {
  id: number
  title: string
  image?: string | null
  itemsCount: number
  className?: string
}
// TODO refactor to FC
class WorkspaceCard extends PureComponent<IWorkspaceCardProps> {
  render() {
    const { title, image, itemsCount, id } = this.props
    const imageClass = !image ? 'no-image' : 'has-image'
    const classes = classNames(
      'WorkspaceCard',
      imageClass,
      this.props.className
    )

    return (
      <Card
        linkUrl={linkBuilder.workspaceUrl(id)}
        className={classes}
        image={image}
      >
        <CardTitle
          title={title}
          subtitleDark={!image}
          subtitle={
            <Flex align="center">
              <IconDoc boxSize="14px" mr="4px" />
              <Plural value={itemsCount} one="# resource" other="# resources" />
            </Flex>
          }
        />
      </Card>
    )
  }
}

export default WorkspaceCard
